/** Window title and screen-reader status for a skeleton loading screen. */

import { VisuallyHidden, WindowTitle } from 'component/basics';
import { UtilityText } from 'component/text';
import type { TLabel } from 'util/stdtypes';
import { t } from 'util/stdtypes';

type LoadingAnnouncementProps = {
    label?: TLabel;
};

export function LoadingAnnouncement({ label = t('loading', 'Loading...') }: LoadingAnnouncementProps) {
    return (
        <>
            <WindowTitle label={label} />
            <VisuallyHidden aria-live='polite' role='status'>
                <UtilityText label={label} />
            </VisuallyHidden>
        </>
    );
}
